
import { Component, Mixins } from "vue-property-decorator";

@Component({
})
export default class DeveloperQuittableMixin extends Mixins() {
  quitDeveloperMode(): void {
    // chromeでは自windowで更新したstorageイベントが飛ばないので別windowで閉じる.
    this.$openWindow("/BackDoor/Close");
  }
}
